import { render, staticRenderFns } from "./Taxcode.vue?vue&type=template&id=83b90066&scoped=true&"
import script from "./Taxcode.vue?vue&type=script&lang=js&"
export * from "./Taxcode.vue?vue&type=script&lang=js&"
import style0 from "./Taxcode.vue?vue&type=style&index=0&id=83b90066&prod&scoped=true&lang=css&"
import style1 from "./Taxcode.vue?vue&type=style&index=1&id=83b90066&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b90066",
  null
  
)

export default component.exports